import React, { useState, useEffect } from "react";
import {
  getUsers,
  getFilterUsers,
  deleteUser,
} from "../../actions/user-actions";
import { getProfilePosition } from "../../actions/position-actions";
import { TablePagination, Typography } from "@material-ui/core";
import { getMaestras } from "../../actions/maestras-actions";
import ModalConfirm from "../../utils/form/modalConfirmBase";
import { useStateValue } from "../../context/store";
import Search from "../../images/icons/search.svg";
import { withRouter } from "react-router-dom";
import { headers } from "./userModels";
import UserSearch from "./userSearch";
import TableUser from "./tableUser";
import { styles } from "../styles";
import { permissionsConstans } from "../../constansPermissions";
import _ from "lodash";

const Users = (props) => {
  const classes = styles();
  const [{ filterUser }, dispatch] = useStateValue();
  const [idToEdit, setIdToEdit] = useState(0);
  const [charges, setCharges] = useState([]);
  const [refrehs, setRefresh] = useState(false);
  const [users, setUsers] = useState([]);
  const [showEdit, setShowEdit] = useState(false);
  const [data, setData] = useState({
    username: null,
    email: null,
    firstName: null,
    secondName: null,
    surname: null,
    document: null,
    documentType: null,
    status: null,
    type: null,
    initDate: null,
    endDate: null,
    chargeDenomination: null,
  });

  const [maestras, setMaestras] = useState({
    generos: [],
    tipoDocumnetoIdentificacion: [],
  });
  
  const [paginadorRequest, setPaginadorRequest] = useState({
    page: 0,
    size: 10,
    order: "DESC",
    columnOrder: "creationDate",
  });

  const [paginadorResponse, setPaginadorResponse] = useState({
    data: [],
    totalRows: 0,
    pageSize: 0,
    pageNumber: 0,
  });
  
  const [message, setMessage] = useState({
    description: "",
    textButtonSubmit: "",
    title: "",
    handleClick: () => {},
    handleClickOut: () => {},
    oneButtons: false,
    type: "",
    open: false,
  });

  const refreshTable = () => setRefresh(!refrehs);

  const getListCharges = async () => {
    const response = await getProfilePosition("ACTIVO");
    setCharges(
      _.sortBy(response?.data?.chargeList, [
        function (o) {
          return o.denomination;
        },
      ])
    );
  };

  const handleClickClose = () => {
    setMessage({ ...message, open: false });
  };

  const show = async () => {
    const response = await getUsers();
    setUsers(response.data.personList);
  };

  const getListaMaestras = async () => {
    const response = await getMaestras();
    setMaestras(response.data.maestras);
  };

  const changePage = (event, nuevaPagina) => {
    setPaginadorRequest((anterior) => ({
      ...anterior,
      page: parseInt(nuevaPagina),
    }));
  };

  const changeAmountOfRecords = (event) => {
    setPaginadorRequest((anterior) => ({
      ...anterior,
      size: parseInt(event.target.value),
      page: 0,
    }));
  };

  const getReqs = async () => {
    const response = await getFilterUsers(
      {
        username: data.username === "" ? null : data.username,
        email: data.email === "" ? null : data.email,
        firstName: data.firstName === "" ? null : data.firstName,
        secondName: data.secondName === null ? "" : data.secondName,
        surname: data.surname === "" ? null : data.surname,
        document: data.document === "" ? null : data.document,
        documentType: data.documentType === "" ? null : data.documentType,
        status: data.status === "" ? null : data.status,
        type: data.type === "" ? null : data.type,
        initDate: data.initDate === "" ? null : data.initDate,
        endDate: data.endDate === "" ? null : data.endDate,
        chargeDenomination:
          data.chargeDenomination === "" ? null : data.chargeDenomination,
      },
      {
        page: paginadorRequest.page,
        size: paginadorRequest.size,
        order: paginadorRequest.order,
        columnOrder: paginadorRequest.columnOrder,
      },
      dispatch
    );
    //if (response && response.status === 200 || response.status === 201) {
    if (response?.data) {
      const data = response?.data?.userResponsePageList;
      if (data?.content?.length > 0) {
        let infoUser = data?.content?.person?.secondName;
        if (infoUser !== null) {
          infoUser = data?.content?.person?.secondName;
        } else {
          infoUser = "";
        }
        setPaginadorResponse({
          data: data?.content,
          totalRows: data?.totalElements,
          pageSize: data?.size,
          pageNumber: data?.number,
        });
      } else {
        setPaginadorResponse({
          data: [],
          totalRows: 0,
          pageSize: 0,
          pageNumber: 0,
        });
      }
    } else if (data === undefined) {
      setPaginadorResponse({
        data: [],
        totalRows: 0,
        pageSize: 0,
        pageNumber: 0,
      });
    } 
     
    else if (response?.status > 399 && response?.status !== 401 && response?.status !==403) {
      setMessage({
        description: response?.data?.detail,
        textButtonSubmit: "ACEPTAR",
        handleClick: () => handleClickClose(),
        oneButtons: true,
        type: "WARNING",
        open: true,
      });
    } 
     else {
      setPaginadorResponse({
        data: [],
        totalRows: 0,
        pageSize: 0,
        pageNumber: 0,
      });
    }
  };

  useEffect(() => {
    getReqs();
    getListCharges();
    getListaMaestras();
    show();
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Usuarios",
      breadCrumbSubText: "Usuarios",
      index: 3,
      path: "/dashboard/user/create",
    });
  }, [refrehs, paginadorRequest]);

  if (filterUser && filterUser?.isFilter && data !== filterUser.filter) {
    const newfilter = filterUser.filter;
    data.username = newfilter.username;
    data.email = newfilter.email;
    data.firstName = newfilter.firstName;
    data.surname = newfilter.surname;
    data.document = newfilter.document;
    data.documentType = newfilter.documentType;
    data.status = newfilter.status;
    data.type = newfilter.type;
    data.chargeDenomination = newfilter.chargeDenomination;
    data.initDate = newfilter.initDate;
    data.endDate = newfilter.endDate;
    paginadorRequest.page = 0;
    getReqs();
    dispatch({
      type: "SET_FILTER",
      isFilter: false,
    });
  }

  const handleClickOut = () => setMessage({ ...message, open: false });
  const handleClickReset = () => {
    setMessage({ ...message, open: false });
    getReqs();
  };
  const closeEdit = () => {
    setMessage({ ...message, open: false });
    getReqs();
    toggleEditBtn();
  };

  const receiveIdToDelete = async (id) => {
    const response = await deleteUser(id);
    if (response?.status >= 200 && response?.status < 399) {
      setMessage({
        description: `Usuario eliminado exitosamente`,
        textButtonSubmit: "Aceptar",
        handleClick: () => handleClickReset(),
        type: "SUCCESS",
        oneButtons: true,
        open: true,
      });
    } else if (response?.status > 399 && response?.status !== 401 && response?.status !==403) {
      setMessage({
        description: `Ocurrió un error procesando la solicitud, inténtelo nuevamente`,
        textButtonSubmit: "ACEPTAR",
        handleClick: () => handleClickOut(),
        oneButtons: true,
        type: "WARNING",
        open: true,
      });
    } else {
      setMessage({
        description: `Ocurrió un error procesando la solicitud, inténtelo nuevamente`,
        textButtonSubmit: "ACEPTAR",
        handleClick: () => handleClickOut(),
        oneButtons: true,
        type: "WARNING",
        open: true,
      });
    }
  };

  const ver = (id) => alert(id);

  const toggleEditBtn = () => setShowEdit(!showEdit);

  const anular = (dataUser) => {
    setMessage({
      description: `¿Está seguro que desea eliminar este usuario?`,
      title: "Eliminar",
      textButtonSubmit: "Aceptar",
      handleClick: () => receiveIdToDelete(dataUser),
      handleClickOut: () => handleClickOut(),
      type: "QUESTION",
      open: true,
    });
  };

  const editar = (userId) => {
    setIdToEdit(userId);
    setShowEdit(!showEdit);
  };

  const validationPermission = () => {
    const state = JSON.parse(localStorage.getItem("state"));
    const module = state?.permissions.find((x) => x.code === "USU");

    if (
      module?.functionalities?.some(
        (x) => x === permissionsConstans.USU_CONSULTAR
      )
    ) {
      return (
        <React.Fragment>
          <Typography className={classes.titleCreate}>
            Información usuarios
          </Typography>
          <UserSearch
            currentData={users}
            maestras={maestras}
            charges={charges}
          />
        </React.Fragment>
      );
    } else return null;
  };

  return (
    <div style={{ marginTop: "40px" }}>
      {validationPermission()}

      {paginadorResponse?.data?.map((row, index) => (
        <TableUser
          headers={headers}
          data={row}
          onView={ver}
          onEdit={editar}
          onDelete={anular}
          refresh={refreshTable}
          charges={charges}
          setMessage={setMessage}
          message={message}
          handleClickReset={closeEdit}
        />
      ))}

      {paginadorResponse?.totalRows !== 0 ? (
        <TablePagination
          style={{ display: "flex", justifyContent: "center" }}
          rowsPerPageOptions={[5, 10, 15]}
          count={paginadorResponse.totalRows}
          rowsPerPage={paginadorRequest.size}
          page={paginadorRequest.page}
          labelRowsPerPage="Registros por página"
          onChangePage={changePage}
          onChangeRowsPerPage={changeAmountOfRecords}
        />
      ) : (
        <React.Fragment>
          <div className={classes.messageSearch}>
            <img src={Search} alt="" />
            <Typography style={{ paddingTop: "20px", paddingLeft: "20px" }}>
              No se encontraron registros que coincidan con el filtro de
              búsqueda aplicado
            </Typography>
          </div>
        </React.Fragment>
      )}
      <ModalConfirm
        description={message.description}
        textButtonSubmit={message.textButtonSubmit}
        handleClick={message.handleClick}
        handleClickOut={message.handleClickOut}
        oneButtons={message.oneButtons}
        title={message.title}
        type={message.type}
        open={message.open}
      />
    </div>
  );
};

export default withRouter(Users);
